import "../style/CardSkeleton.css";

const CardSkeleton = () => {
    return (
        <div className="cs-wrapper">
            <div className="cs-card">
                <div className="cs-heading cs-skeleton"></div>

                <div className="cs-cardSkeletonBody">
                    <div className="cs-left">
                        <div className="cs-big-number cs-skeleton"></div>
                        <div className="cs-small-line cs-skeleton"></div>

                        <div className="cs-stats">
                            <div className="cs-stat-block">
                                <div className="cs-stat-small cs-skeleton"></div>
                                <div className="cs-stat-label cs-skeleton"></div>
                            </div>

                            <div className="cs-stat-block">
                                <div
                                    className="cs-stat-small cs-skeleton"
                                ></div>

                                <div
                                    className="cs-stat-label cs-skeleton"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardSkeleton;
